import { motion } from "framer-motion";
import { APP_CATEGORIES } from "../../data/site";

export default function AppCategories() {
  return (
    <section
      id="categories"
      className="py-20 md:py-28 bg-white"
      data-testid="categories-section"
    >
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="text-overline text-electric mb-3">03 — Industries</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal text-balance">
              Marketing That Works for Your Industry — Not Generic Advice
            </h2>
          </div>
          <p className="lg:col-span-4 text-zinc-500 leading-relaxed">
            We've built proven playbooks across 15+ industries. Pick yours — we
            already know its buyer psychology, seasonality, and best-converting
            channels.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {APP_CATEGORIES.map((c, idx) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.label}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: idx * 0.04 }}
                className="group aspect-square bg-white rounded-2xl border border-zinc-100 shadow-card p-5 flex flex-col items-start justify-between hover:shadow-glow-sm hover:border-electric/20 hover:-translate-y-1 transition-all duration-300"
                data-testid={`category-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="w-10 h-10 grid place-items-center rounded-xl bg-electric/10 group-hover:bg-electric transition-colors">
                  <Icon
                    className="w-5 h-5 text-electric group-hover:text-white transition-colors"
                    strokeWidth={2}
                    aria-hidden
                  />
                </div>
                <div>
                  <div className="font-display text-sm font-semibold text-charcoal group-hover:text-electric transition-colors leading-tight">
                    {c.label}
                  </div>
                  <div className="text-[10px] text-zinc-400 mt-0.5">
                    We specialize
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
